import MessageGenericView from "./message.generic.view";
import _ from 'underscore';
import Handlebars from 'handlebars';
import PayPalTemplate from 'js/templates/partials/message.report.paypal.payment.tile.partial.hbs';
import OptinTemplate from 'js/templates/partials/message.report.optin.tile.partial.hbs';
import UserModel from 'js/models/userrelatedinfo.model';
import Template from 'js/templates/message.report.hbs';
import i18n from 'l10n';
import PromoRowView from 'js/views/promo.row.view';
import ReportView from 'js/views/subscribers.report.view';
import ServiceModel from 'js/models/service.config.model';
import ContentModel from 'js/models/content.model';
import PreviewTemplate from 'js/templates/content.preview.hbs';
import ContentUsageCollection from 'js/models/content.usage.paginated.collection';
import PaginatedView from 'js/views/pagination.view';
import ChartView from 'js/views/trigger-report-chart-simpleview';
import dhtmlx from 'dhtmlxAdapter';
import gMaps from 'gMaps';
import {el, on, template} from "js/adapters/backbone-decorators";
import * as Optional from "optional-js";

var Parser = require('tellody').parser;

var contentModel = new ContentModel();

@template(Template)
@el("#report-message")
class MessageReportView extends MessageGenericView {

    constructor(options) {
        super(options);
        this.PreviewTemplate = PreviewTemplate;
        this.creditRatio = 1;
        this.SMScount = 1;
        this.charactersCount = 0;
        this.isMessageSaved = true;
        this.voucherNotificationShown = false;
        this.isUrlValid = true;
        this.isVoucherValid = true;
        this.areCreditsEnough = true;
        this.myModel = null;
        this.optinTemplate = Handlebars.compile(OptinTemplate);
        this.payPalTemplate = Handlebars.compile(PayPalTemplate);

        options.isMessageReport = true;
        // this.superInitialize(options);
        this.load().then("message.report.view loaded");
        this.myModel = options.model;
        this.setContactsExpanded(_.bind(this.contactsExpanded, this));
        this.awaitsForMessagesToBeSent = options.awaitsForMessagesToBeSent;
    }

    @on('click #stopScheduledCampaign')
    executeCancel() {
        return super.executeCancel();
    }

    render(extras) {
        this.model.set("postpaid", this.userModel.get("postpaid"));
        this.model.set("tellody_event", this.model.get("campaignTemplateType") === 'SMART_NOTIFICATION');
        this.model.set("active", this.model.get("campaignStatus") === "ACTIVE" || this.model.get("campaignStatus") === "COMPLETED");
        this.model.set("lng", i18n.language);
        this.model.set("awaitsForMessagesToBeSent", this.awaitsForMessagesToBeSent);
        super.render(extras);

        var $iFrame = $("#message-isolation");
        var $footer = $("<div>")
            .html(this.standardFooter)
            .addClass("email-footer");
        var $isolator = $("<div>").css("all", "initial").append($footer);
        $iFrame.after($isolator);
        var footerHeight = $footer.height();

        $iFrame.on('load', function () {
            var $ifrDoc = $iFrame.contents();
            var $ifrHtml = $ifrDoc.find('html');
            $iFrame.height($ifrHtml.height());
            $(".email-footer").attr('style', $ifrHtml.find('body').attr('style'));
        });

        this.showDependencyGraph();

        if (this.model.get("campaignTemplateType") === 'SMART_NOTIFICATION') this.getRatios();

        this.voucherModel = new ServiceModel();
        this.surveyModel = new ServiceModel();

        this.loadVoucher();
        this.loadSurvey();

        // this.reportAccordion = this.$("#report-contacts .accordion");
        // this.reportAccordion.accordion({
        //     action: frame => {
        //         if (this.model.get("campaignId") > 0) {
        //             if (frame.find(".heading").hasClass("collapsed")) {
        //                 frame.find(".accordion-prompt").text(i18n.t("message.editrecipients"));
        //                 if (this.contactsCollapsed) {
        //                     this.contactsCollapsed();
        //                 }
        //             } else {
        //                 frame.find(".accordion-prompt").text(i18n.t("content.close"));
        //                 this.reportView.drawTabs();
        //                 if (this.contactsExpanded) {
        //                     this.contactsExpanded();
        //                 }
        //             }
        //         }
        //     }
        // });

        var channel = this.model.get("campaignChannel");

        this.$("#messages-count").text(this.SMScount);

        this.$("#editor").text(this.model.get("message"));
        this.$("#editor2").text(this.model.get("successMessage"));

        if (channel === "SMS") {
            this.showSMSMessages(this);
        }

        var optoutForUniqueCode = null;
        if (this.model.get("message").indexOf("{UURL.optout}") > -1)
            optoutForUniqueCode = true;

        const campaignId = this.model.get("campaignId");
        this.reportView = new ReportView({
            el: "#report-contacts",
            CCview: this,
            campaignId: campaignId,
            campaignChannel: this.model.get("campaignChannel"),
            includedGroups: this.model.get("includedGroups"),
            voucherId: this.model.get("voucherForUniqueCode"),
            surveyId: this.model.get("surveyForUniqueCode"),
            contentForUniqueCode: this.model.get("contentForUniqueCode"),
            urlForUniqueCode: this.model.get("urlForUniqueCode"),
            optoutForUniqueCode: optoutForUniqueCode
        });
        this.reportView.load();

        this.getUniqueCodeUsageCount();
        this.getMultipleUrlUsageCount();
        // this.fillMultipleUrlUsageTemplate();
        this.getRecipientsCount();
        if (this.model.get("contentForUniqueCode")) {
            this.getFileContent(this);
        }
        this.$("#message-isolation").contents().find("a").attr("href", null);

        const delay = this.convertSeconds(this.model.get('delayDuration'));
        $("#delay").text(delay);

        if (this.model.get("campaignTemplateType") === "SMART_NOTIFICATION") {
            const chartView = new ChartView(campaignId, `/CampaignCloud/Report/TriggerMessageRange/${campaignId}`);
            chartView.init('.container');
        }
        return this;
    }

    setContactsExpanded(fn) {
        this.contactsExpanded = fn;
    }

    setContactsCollapsed(fn) {
        this.contactsCollapsed = fn;
    }

    async load(id) {
        try {
            await this.loadFooter();
        } finally {
            try {
                await this.loadUser();
                const selectedShops = Optional.ofNullable(this.model.get("triggeringCriterionExpression"))
                    .filter(exp => exp.includes("Woo"))
                    .map(exp => exp.split("\\")[1])
                    .filter(criterion => criterion.includes(" in "))
                    .map(criterion => criterion.substring(criterion.indexOf("{"))
                        .replace("{", "[")
                        .replace("}", "]"))
                    .map(JSON.parse);

                const extras = {};
                if (selectedShops.isPresent()) {
                    const {data} = await $.getDefaultJSONQ("/CampaignCloud/ApiUser/WooShops");
                    extras.wooShops = data.filter(({id}) => selectedShops.get().includes(id));
                }
                this.render(extras);
            } catch (e) {
                console.error(e);
            }
        }
    }

    //same as message.mail.vew::loadInner
    loadFooter() {
        var self = this;
        return $.ajaxDefaultQ({
            url: '/CampaignCloud/Message/getFooter',
            type: 'GET',
            contentType: 'application/json'
        }).done(function (response) {
            self.standardFooter = response.footer;
        }).fail(function () {
            console.error("Failed to get standard footer");
        });
    }

    loadUser(callback) {
        this.userModel = new UserModel();
        return this.userModel.fetch({
            success: function () {
                if (_.isFunction(callback))
                    callback();
            }
        });
    }

    loadVoucher() {
        //check if it contains voucher and add appropriate prefix for triggered ones.
        if (this.model.get('voucherForUniqueCode')) {
            this.loadProperService("voucher", "", this.model.get('voucherForUniqueCode')); //normal campaigns
        }
        if (this.model.get("triggeringCriterionExpression") && this.model.get("triggeringCriterionExpression").indexOf("RedeemVoucherEvent") !== -1) {
            var triggeredCampaignId = this.model.get("triggeringCriterionExpression").indexOf("RedeemVoucherEvent") !== -1
                ? this.model.get("triggeringCriterionExpression").replace("RedeemVoucherEvent\\campaignId=", "")
                : null;
            this.loadProperService("voucher", "trigger-", triggeredCampaignId); //triggered campaigns
        }
    }

    loadSurvey() {
        //check if it contains survey and add appropriate prefix for triggered ones.
        if (this.model.get('surveyForUniqueCode')) {
            this.loadProperService("survey", "", this.model.get('surveyForUniqueCode')); //normal campaigns
        }
        var triggeringCriterionExpression = this.model.get("triggeringCriterionExpression");
        var isSurveyEventCampaign = triggeringCriterionExpression ? (triggeringCriterionExpression.indexOf("SurveyAnswerRequest") !== -1) : false;
        var isPayPalPaymentEventCampaign = triggeringCriterionExpression ? ((triggeringCriterionExpression.indexOf("PayPalPaymentEvent") !== -1) || (triggeringCriterionExpression.indexOf("EmailOptedInEvent") !== -1)) : false;
        var isInstantWinActedWinnerEventCampaign = triggeringCriterionExpression ? (triggeringCriterionExpression.indexOf("InstantWinActedWinnerEvent") !== -1) : false;
        var isInstantWinActedParticipantEventCampaign = triggeringCriterionExpression ? (triggeringCriterionExpression.indexOf("InstantWinActedParticipantEvent") !== -1) : false;
        if (triggeringCriterionExpression && (isSurveyEventCampaign || isPayPalPaymentEventCampaign
            || isInstantWinActedWinnerEventCampaign || isInstantWinActedParticipantEventCampaign)) {
            var indexOf = triggeringCriterionExpression.indexOf("=");
            var triggeredCampaignId = triggeringCriterionExpression.substring(indexOf + 1, triggeringCriterionExpression.length);
            this.loadProperService(isSurveyEventCampaign ? "survey" : (isPayPalPaymentEventCampaign ? "PayPalpayment" : "instantWin"), "trigger-", triggeredCampaignId); //triggered campaigns
        }
    }

    async loadProperService(type, prefix, serviceCampaignId) {
        // This logic works for optin too.
        const triggeringCriterionExpression = this.model.get("triggeringCriterionExpression");

        const tempModel = prefix !== "trigger-"
            ? (type === "survey") ? this.surveyModel : this.voucherModel
            : new ServiceModel();
        tempModel.url = `/CampaignCloud/Config/campaignId/${serviceCampaignId}`;

        const response = await tempModel.fetch();
        const campaignTemplateType = response.campaignTemplateType;

        if (campaignTemplateType === "PAY_PAL_PAYMENT") {
            $('#tile').html(this.payPalTemplate(this.model));
            if (triggeringCriterionExpression.indexOf("PayPalPaymentEvent") !== -1)
                $('#payment-trigger').show();
            else if (triggeringCriterionExpression.indexOf("EmailOptedInEvent") !== -1)
                $("#optin-trigger").show();

        } else if (["EMAIL_OPTIN", "QUIZ_OPTIN"].includes(campaignTemplateType)) {
            // Because email opted in event goes to both.
            $('#tile').html(this.optinTemplate(this.model));
            type = "optin";
        }
        $(`#${prefix}${type}-link`).attr('href', `Service.htm#${response.id}`);
        var title = response.title;
        var dictionaryName = `noname${tempModel.get("description")}`;

        const defaults = {
            survey: `survey.${dictionaryName}`,
            voucher: "voucher.nonameservice",
            optin: "optin.noTitle",
            instantWin: "optin.noTitle",
            PayPalpayment: "payPalPayment.noTitle"
        };

        title = title || i18n.t(defaults[type]);

        $(`#${prefix}${type}-title`).text(title);

        var serviceStatus = tempModel.get("campaignStatus"); //response[index][serviceCampaignId];
        if (prefix === "trigger-") {
            switch (type) {
                case "survey":
                    this.triggeredSurveyModel = tempModel;
                    break;
                case "voucher": //type = "voucher"
                    this.triggeredVoucherModel = tempModel;
                    break;
                case "optin":
                case "instantWin":
                case "PayPalpayment":
                    this.triggeredOptinModel = tempModel;
                    break;
            }
        } else {
            if (type === "survey") {
                this.surveyModel = tempModel;
            } else { //type = "voucher"
                this.voucherModel = tempModel;
            }
        }
        if (serviceCampaignId === this.model.get(`${type}ForUniqueCode`)) {
            //for Services used inside the triggered campaign
            this.setStatusFor(type, tempModel, serviceStatus, "");
        } else {
            //for services that are used AS triggers on campaigns
            this.setStatusFor(type, tempModel, serviceStatus, prefix);
        }

        if (type === "survey") {
            this.setSurveyScore(prefix, serviceCampaignId);
        }

    }

    setSurveyScore(prefix, surveyCampaignId) {
        $.ajaxDefaultQ({
            url: `/CampaignCloud/Report/${surveyCampaignId}/getAverageOfStarRatingForCampaign`,
            type: 'GET',
            dataType: 'json'
        }).done(data => {
            if (!data[0]) {
                this.$(`#${prefix}surveyScore`).text("-");
            } else {
                var score = (data[0].averageRating * 100).toFixed(0) + "%";
                this.$(`#${prefix}surveyScore`).text(score);
            }
        }).fail(function (data) {
            console.error(data);
        });
    }

    renderCollection() {
        var model = contentModel;
        var ccView = this.model;
        var parentContentCollectionView = this;
        var fileType = contentModel.get("fileType");
        var fileSubType = contentModel.get("fileSubType");
        var filePath = contentModel.get("filePath");
        var filename = contentModel.get("filename");
        var fileLength = contentModel.get("fileLength");
        var uploadedOn = contentModel.get("created");
        var inPromoConfiguration = false;
        var inVoucherConfiguration = false;
        var inContentManagement = true;
        var hasStatisticsToShow = this.ContentUsageCollection.hasStatisticsToShow;
        var totalSent = this.ContentUsageCollection.totalSent;
        var totalViewed = this.ContentUsageCollection.totalViewed;
        var canDelete = this.ContentUsageCollection.canDelete;
        var contentUsages = this.ContentUsageCollection.models;
        var contentId = this.model.get("contentForUniqueCode");
        this.collectionPreviewTemplate = Handlebars.compile(PreviewTemplate)({
            "contentId": contentId,
            "fileType": fileType,
            "filePath": filePath,
            "filename": filename,
            "fileLength": fileLength,
            "fileSubType": fileSubType,
            "inPromoConfiguration": inPromoConfiguration,
            "inVoucherConfiguration": inVoucherConfiguration,
            "hasStatisticsToShow": hasStatisticsToShow,
            "totalSent": totalSent,
            "totalViewed": totalViewed,
            "inContentManagement": inContentManagement,
            "contentUsages": contentUsages,
            "canDelete": canDelete,
            "uploadedOn": uploadedOn
        });
        var content = $($.Metro.METRO_DIALOG.children(".content"));
        content.html(this.collectionPreviewTemplate);
        var $window = $('.window.shadow');
        $window.css("height", "auto");
        $window.css("top", "15px");
        this.$('[data-i18n]').i18n();
        if (inContentManagement && this.ContentUsageCollection.hasStatisticsToShow) {
            if (this.paginationReport) {
                this.paginationReport.remove();
            }
            // Render collection the 1st time
            this.paginationReport = new PaginatedView({collection: this.ContentUsageCollection});
            this.paginationReport.render();
            // Replace view's pagination
            $('#pagination-report').html(this.paginationReport.$el);
        }
    }

    loadContentUsage() {
        this.ContentUsageCollection.url = `/CampaignCloud/Report/contentUsageStatistics/${contentModel.get("contentId")}`;
        this.ContentUsageCollection.getFirstPage();
        console.info("Fetching content statistics");
    }

    @on('click #clone')
    async cloneCampaign() {
        try {
            const id = await $.postDefaultQ(`/CampaignCloud/Message/${this.model.get("id")}/clone`);
            if (location.href.includes(`Message.htm#${id}`)) {
                if (this.model.get("description") === "nameday")
                    $.Notify.error(i18n.t("message.onlyOneActiveNamedayCampaign"));
                else if (this.model.get("description") === "birthday")
                    $.Notify.error(i18n.t("message.onlyOneActiveBirthdayCampaign"));
            }
            location.href = `Message.htm#${id}`;
        } catch (e) {
            console.log(e);
        }
    }

    @on('click #stopActiveCampaign')
    async stopActiveCampaign() {
        try {
            const result = await dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("message.wantToStopCampaign"),
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no")
            });
            if (result) {
                const data = await $.ajaxDefaultQ({
                    url: `/CampaignCloud/Message/${this.model.get("id")}/stop`,
                    type: 'POST'
                });
                if (data) {
                    await dhtmlx.alert(i18n.t("message.campaignStoppedSuccess"));
                    this.model.set("endDate", Date.now());
                    $("#stopActiveCampaign").parent().remove();
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    @on('click #export_xls')
    async exportXLS() {
        try {
            const result = await dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("message.exportExcel"),
                ok: i18n.t("message.yes")
            });
            if (result) {console.log(this.model);
                const data = await $.ajaxDefaultQ({
                    url: `/CampaignCloud/Message/export?campaignId=${this.model.get("campaignId")}&lng=${this.model.get("lng")}&defaultDateTimeFormat=${i18n.defaultDateFormatJava() + (" HH:mm")}`,
                    type: 'GET'
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    @on('click #create_failed_group')
    async createFailedGroup() {
        try {
            const result = await dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("message.createFailedGroupPrompt"),
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no")
            });
            if (result) {
                console.log(this.model);
                console.log(result);
                const data = await $.ajaxDefaultQ({
                    url: `/CampaignCloud/Group/createFailed/${this.model.get("campaignId")}`,
                    type: 'GET'
                });
                if(data){
                    console.log("DATA EXISTS");
                    console.log(data);
                }
                await dhtmlx.alert(i18n.t("message.confirmCreationOfGroup"));
                window.location.href = `/CampaignCloud/cloudui/home/Contacts.htm#Group/${data}`;
            }
        } catch (e) {
            console.error(e);
        }
    }

    @on('click #create_group_for_not_opened_emails')
    async createGroupForNotOpenedEmails() {
        try {
            const result = await dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("message.createGroupForNotOpenedEmailsPrompt"),
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no")
            });
            if (result) {
                console.log(this.model);
                console.log(result);
                const data = await $.ajaxDefaultQ({
                    url: `/CampaignCloud/Group/createUnopened/${this.model.get("campaignId")}`,
                    type: 'GET'
                });
                if(data){
                    console.log("DATA EXISTS");
                    console.log(data);
                }
                await dhtmlx.alert(i18n.t("message.confirmCreationOfGroup"));
                window.location.href = `/CampaignCloud/cloudui/home/Contacts.htm#Group/${data}`;
            }
        } catch (e) {
            console.error(e);
        }
    }
    
    // This is kinda junky but it works!
    // Thanks c.kaneloglou@msensis.com for the help
    async getMultipleUrlUsageCount() {
        console.log("getMultipleUrlUsageCount start");
        var counter = 0 ;
        try {
            var response = await $.getDefaultQ("/CampaignCloud/Report/uurl/statistics/campaign/" + this.model.get("campaignId"));
            if (response) {
                $.each(response, function(index, item){
                    counter += item.totalClicks;
                });
                if (response.length == 0) {
                    $("#uurl-counter-1").hide();
                    $("#uurl-counter-2").hide();

                }
                $('#urlsUniqueViewed').text(counter);
                await this.fillMultipleUrlUsageTemplate(response);
            }
        }catch (e) {
        }
    }

    async fillMultipleUrlUsageTemplate(response){

        $("#urlsViewHistory tbody").html("");

        $.each(response, (index, value) => {
            var generatedRow = `<tr class="row-of-import-contact-history">
                    <td title="${value.url}" style="text-overflow: ellipsis; overflow: hidden; width: 40%;">${value.url}</td>
                    <td>${value.totalClicks}</td>
                    <td>${value.uniqueClicks}</td>
                </tr>`;
            $("#urlsViewHistory tbody").append(generatedRow);
        });

        if (response.length == 0) {
            $("#urlsViewHistoryDiv").hide();
        }
    }
    async getUniqueCodeUsageCount() {
        const voucherForUniqueCode = this.model.get("voucherForUniqueCode");
        const surveyForUniqueCode = this.model.get("surveyForUniqueCode");
        const expression = this.model.get("triggeringCriterionExpression");

        const extractCId = (c, t) => t && t.includes(c) ? t.replace(`${c}\\campaignId=`, "") : 0;

        var formValues = {
            campaignId: this.model.get("campaignId"),
            voucherId: voucherForUniqueCode || 0,
            surveyId: surveyForUniqueCode || 0,
            triggeredVoucherId: extractCId("RedeemVoucherEvent", expression),
            triggeredSurveyId: extractCId("SurveyAnswerRequest", expression)
        };

        try {
            const {
                URL,
                DL,
                Opt,
                VOUCHER,
                Redeems,
                pointsRedeems,
                SURVEY,
                FilledIns,
                TriggeredRedeems,
                TriggeredFilledIns
            } = await $.getDefaultQ("/CampaignCloud/Report/UniqueCodeUsageCount/", formValues);

            $('#link-count-view').text(i18n.t("message.countviews", {count: URL}));
            $('#link-count-view2').text(i18n.t("message.countviews2", {count: URL}));
            $('#file-count-view').text(i18n.t("message.countviews", {count: DL}));
            $('#file-count-view2').text(i18n.t("message.countviews2", {count: DL}));
            $('#voucher-count-view').text(i18n.t("message.countviews", {count: VOUCHER}));
            $('#voucher-count-view2').text(i18n.t("message.countviews2", {count: VOUCHER}));
            $('#optout-count').text(Opt);
            if (this.voucherModel.get("description") === "points") {
                $('#voucher-count-redeemed').text(i18n.t("message.countredeemed", {count: pointsRedeems}));
                $('#voucher-count-redeemed2').text(i18n.t("spamAssassinPoints"));
            } else {
                $('#voucher-count-redeemed').text(i18n.t("message.countredeemed", {count: Redeems}));
                $('#voucher-count-redeemed2').text(i18n.t("message.countredeemed2", {count: Redeems}));
            }
            $('#survey-count-view').text(i18n.t("message.countviews", {count: SURVEY}));
            $('#survey-count-view2').text(i18n.t("message.countviews2", {count: SURVEY}));
            $('#survey-count-filledins').text(i18n.t("message.countfilledin", {count: FilledIns}));
            $('#survey-count-filledins2').text(i18n.t("message.countfilledin2", {count: FilledIns}));
            $('#filledinSurveys').text(FilledIns);
            $('#urlsViewed').text(URL);
            $('#filesViewed').text(DL);
            $('#redeemedVouchers').text(Redeems);

            //for triggeredServices
            $("#trigger-voucher-count-redeemed").text(i18n.t("message.countredeemed", {count: TriggeredRedeems}));
            $("#trigger-survey-count-filledins").text(i18n.t("message.countfilledin", {count: TriggeredFilledIns}));
            $("#trigger-voucher-count-redeemed2").text(i18n.t("message.countredeemed2", {count: TriggeredRedeems}));
            $("#trigger-survey-count-filledins2").text(i18n.t("message.countfilledin2", {count: TriggeredFilledIns}));

        } catch (e) {
            console.error(e);
        }
    }

    async getRecipientsCount() {
        const {status, recipients} = await $.ajaxDefaultQ({
            url: '/CampaignCloud/Report/RecipientsAndStatusForEndedCampaign',
            type: 'GET',
            dataType: "json",
            data: {campaignId: this.model.get("campaignId")}
        });
        this.model.set('numberOfContacts', recipients);
        var view = new PromoRowView({model: this.model});
        $("#numberOfContacts").html(recipients);
        $('#message-content').append(view.render().el);
        var $message = $('#message-link');
        $message.css('cursor', 'default');
        $('#promo-message').text('');
        $message.prop("disabled", true);

        var campaignStatus = function (status) {
            if (status === 'NOT_STARTED') {
                return i18n.t('message.scheduled');
            } else if (status === 'ACTIVE' || status === 'COMPLETED') {
                return i18n.t('message.active');
            } else if (status === 'STARTING') {
                return i18n.t('message.starting');
            } else {
                return i18n.t('message.ended');
            }
        };
        $('#campaign-status').text(campaignStatus(status));
        if (status !== 'NOT_STARTED') {
            this.getEmailSMSCount(this);
        } else {
            this.setDefaultValuesOnTiles();
        }

    }

    getRatios() {
        var self = this;
        $.ajaxDefaultQ({
            url: `/CampaignCloud/Report/getRatios/${self.model.get("campaignId")}`,
            type: 'GET',
            dataType: "json"
        }).done(function (response) {
            $("#targetedRatio").text(response.targetedRatio + "%");
            $("#controlledRatio").text(response.controlledRatio + "%");
        });
    }

    getEmailSMSCount(self) {
        var formValues = {
            campaignId: self.model.get("campaignId"),
            campaignType: self.model.get('campaignChannel')
        };
        $.ajaxDefaultQ({
            url: '/CampaignCloud/Report/emailCreditsUsedAndReserved',
            type: 'GET',
            data: formValues,
            dataType: "json"
        }).done(function (response) {
            $('#credits-report-tile').show();
            let openRateEmailPercentage = 0;
            if (self.model.get('campaignChannel') === 'SMS') {
                $('#smsoremail-count').text(response.SMS_COUNT);
                $('#credits-count').text(parseFloat(response.SMS_COST).toFixed(2));
            } else {
                $('#smsoremail-count').text(response.EMAIL_COUNT);
                $('#credits-count').text(parseFloat(response.EMAIL_COST).toFixed(2));
            }
            $('#smsoremail-failed-count').text(response.MESSAGES_FAILED_COUNT || 0);
            if (response.CREDITS_RESERVED) {
                $("#reserved-credits").text(response.CREDITS_RESERVED.toFixed(2));
                $("#reserved-credits-tile").show();
            }
            if (response.EMAILS_RESERVED) {
                $("#reserved-emails").text(response.EMAILS_RESERVED);
                $("#reserved-emails-tile").show();
            }
            if (response.EMAIL_COUNT != 0) {
                openRateEmailPercentage = ((response.OPEN_EMAIL / response.EMAIL_COUNT) * 100).toFixed(2);
            }
            $('#openEmails').text(response.OPEN_EMAIL);
            $('#openEmailsRate').text(openRateEmailPercentage + "%");

        }).fail(function (response) {
            console.info(response);
        });
    }

    setDefaultValuesOnTiles() {
        $('#smsoremail-count').text("-");
        $('#credits-count').text("-");
    }

    showSMSMessage(self, editor, idSuffix) {
        if (!$("#editor" + idSuffix).length) {
            return;
        }
        this[editor] = window.ace.edit("editor" + idSuffix);
        this[editor].setTheme("ace/theme/chrome");
        this[editor].getSession().setMode("ace/mode/custom");
        this[editor].getSession().setUseWrapMode(true);
        this[editor].setOption("showPrintMargin", false);
        this[editor].$blockScrolling = Infinity;
        this[editor].setReadOnly(true);
        var tokens = [];
        var totalRows = self[editor].session.getLength();

        var count = 0;
        var urlCount = 0;
        var downloadCount = 0;
        var voucherCount = 0;
        var optoutCount = 0;
        var firstnameCount = 0;
        var surnameCount = 0;
        var dateOfBirthCount = 0;
        self.$('#message-save').show();

        for (var i = 0; i < totalRows; i++) {
            var token = self[editor].session.getTokens(i);

            for (var j = 0; j < token.length; j++) {
                var tokenValue = token[j].value;

                if (token[j].type === "text") {
                    tokenValue = token[j].value;

                    count += tokenValue.length;
                } else if (token[j].type === "double") {
                    count += tokenValue.length * 2;
                } else if (token[j].type === "tag") {

                    var parts = tokenValue.split(/[\{\}]/);
                    parts = parts.filter(function (s) {
                        return s !== "";
                    });

                    for (var k = 0; k < parts.length; k++) {
                        var part = parts[k];

                        const uurlLength = "https://NNNN.tellody.com/u/".length + 5;
                        if (part === "UURL.url") {
                            urlCount++;
                            count += uurlLength;
                        } else if (part === "UURL.urlcode") {
                            urlCount++;
                            count += 5;
                        } else if (part === "UURL.voucher") {
                            voucherCount++;
                            count += uurlLength;
                        } else if (part === "UURL.vouchercode") {
                            voucherCount++;
                            count += 5;
                        } else if (part === "woo.coupon") {
                            voucherCount++;
                            count += uurlLength;
                        } else if (part === "woo.couponcode") {
                            voucherCount++;
                            count += 5;
                        } else if (part === "UURL.download") {
                            downloadCount++;
                            count += uurlLength;
                        } else if (part === "UURL.optout") {
                            optoutCount++;
                            count += uurlLength;
                        } else if (part === "subscriber.name") {
                            firstnameCount++;
                            count += 20;
                        } else if (part === "subscriber.surname") {
                            surnameCount++;
                            count += 35;
                        } else if (part === "subscriber.dateOfBirth") {
                            dateOfBirthCount++;
                            count += 10; //todo This is a ballpark number! StandardTagTranslator does not even implement it!
                        } else {
                            console.info(part + "unknown UURL O.O");
                        }
                    }
                } else {
                    console.info("not known type :O");
                }
            }
            tokens = tokens.concat(token);
        }
        count += totalRows - 1;

        self[`charactersCount${idSuffix}`] = count;
        self[`SMScount${idSuffix}`] = (count > 160 ? Math.ceil(parseInt(count) / 153) : 1);
        self.$(`#characters-count${idSuffix}`).text(count);
        self.$(`#total-characters${idSuffix}`).text((count > 160 ? self.SMScount * 153 : 160));
        self.$(`#messages-count${idSuffix}`).text(self.SMScount);
    }

    showSMSMessages(self) {
        self.showSMSMessage(self, "editor", "");
        if (self.model.get("campaignTemplateType") !== "SMART_NOTIFICATION") return;
        self.showSMSMessage(self, "editor2", "2");
    }

    getFileContent(self) {

        $.ajaxDefaultQ({
            url: '/CampaignCloud/Content/LoadSpecificContentByFileId',
            type: 'GET',
            dataType: "json",
            data: {"contentId": self.model.get("contentForUniqueCode")}
        }).done(function (response) {

            contentModel.set("filename", response.filename);
            contentModel.set("filePath", response.filePath);
            contentModel.set("fileType", response.fileType);
            contentModel.set("fileSubType", response.fileSubType);
            contentModel.set("author", response.author);
            contentModel.set("created", response.created);
            contentModel.set("createdBy", response.createdBy);
            contentModel.set("lastModified", response.lastModified);
            contentModel.set("lastModifiedBy", response.lastModifiedBy);
            contentModel.set("mimeType", response.mimeType);
            contentModel.set("fileLength", response.fileLength);
            contentModel.set("data", response.data);
            contentModel.set("file", response.file);
            contentModel.set("contentId", response.contentId);

            var $image = $("#image-content");
            if (response.mimeType.match(/image\//)) {
                $image.attr('src', '/CampaignCloud/Content/LoadFileContentBytes/' + response.contentId);
            }
            $image.attr('title', response.filename);
            $("#filename").text(response.filename);
            $("#file-details").text(`${Handlebars.helpers.formatBytesSize(response.fileLength, "si")} | ${response.fileSubType}`);
        }).fail(function (response) {
            console.info(response);
        });
    }

    @on("click #view-statistics")
    viewStatistics() {
        var self = this;
        var filename = contentModel.get("filename");
        $.Dialog({
            overlay: true,
            shadow: true,
            icon: '<span class="icon  icon-file" style="color:white"></span>',
            title: filename,
            draggable: true,
            height: 'auto',
            position: ['center', 'center'],
            content: '',
            padding: 0,
            onShow: function () {
                self.ContentUsageCollection = new ContentUsageCollection();
                self.ContentUsageCollection.on('sync', self.renderCollection, self);
                self.loadContentUsage();
            }
        });
    }

    fillInGeographicGroups(myModel) {
        var self = this;
        $("#geographic-groups-container").ready(function () {
            self.maps = {};
            var groups = myModel.get("includedGroups");
            var index = 0, totalGroupsIndex = 0;
            var ccid = myModel.get("id");
            var html = "";
            groups.forEach(function (group) {
                var html = "";
                totalGroupsIndex++;
                if (group.indexOf("q:in bounds") !== -1) {
                    var criterion = group.substring(2, group.length);

                    $.ajaxDefaultQ({
                        url: `/CampaignCloud/Subscription/${self.model.get("campaignChannel")}/CountByGeoCriterion`,
                        type: "GET",
                        data: {criterion: criterion},
                        dataType: "json"
                    }).done(function (re) {
                        html += "       <div class='tile double double-vertical' id='geogroup-" + index + "'>"
                            + "           <div id='map-" + index + "' style='height:250px;width:250px;'></div>"
                            + "                <div class='tile-content' style='padding: 5px !important; display:block'>"
                            + "                   <div class='fg-funkyOrange messagebubble-columnB1 bg-white light text-left padding5' title='" + i18n.t("message.includedcontactsmap") + "' style='display:inline-block; margin-left:0; opacity: 0.8;'>"
                            + "                       <strong id='size-geo-contact' class='groupFontSize text-bold'>" + re + "</strong>"
                            + "                       <i class='icon-user-2 ' style=' font-size: 30%; margin: 0; padding: 0;'></i>"
                            + "                   </div>"
                            + "                </div>"
                            + "       </div>";

                        $("#geographic-groups-container").append(html);

                        var rx = new RegExp('^q\\:in bounds\\((.*),(.*),(.*),(.*)\\)$');
                        var res = rx.exec(group); //Ex: q:in bounds(2.45,4.78,3,42)
                        if (res) {
                            var south = parseFloat(res[1]);
                            var west = parseFloat(res[2]);
                            var north = parseFloat(res[3]);
                            var east = parseFloat(res[4]);
                            var bounds = {south: south, west: west, north: north, east: east};
                            var map = new gMaps.Map($(`#map-${index}`)[0], {
                                center: new gMaps.LatLng((south + north) / 2, (west + east) / 2),
                                zoom: 8,
                                mapTypeId: gMaps.MapTypeId.ROADMAP,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                rotateControl: false
                            });
                            map.fitBounds(bounds);
                            var rectangle = new gMaps.Rectangle({
                                bounds: bounds,
                                editable: false,
                                draggable: false
                            });

                            rectangle.setMap(map);

                            self.maps[group] = map;
                        }

                        index++;
                    }).fail(function (re) {
                        console.info("An error occurred!");
                        console.info(re);
                    });
                } else if (group.indexOf("q:") !== -1) {
                    var query = group.substring(2);
                    var parsedQuery = Parser.parse(query); //todo check it
                    html =
                        $("<div style='width:100%'>"
                            + "           <div id='geogroup-" + index + "' class='criteriaExpression attr:includedGroups[" + index + "] bg-black fg-white' style='padding:5px;width:100%;text-align:center;vertical-align:middle;float:left;display:inline;font-family: \"Mic32 Light\", monospace !important; font-size: 18px; line-height: 20px;'>"
                            + "           </div>"
                            + "</div>");
                    var $noCriteriaExpressions = $("#noCriteriaExpressions");
                    if (!self.isHidden($noCriteriaExpressions)) {
                        $noCriteriaExpressions.hide();
                    }
                    $(html).find("#geogroup-" + index).text(query);
                    $("#criteria-expressions-container").append(html);
                    index++;
                }
            });
        });
    }

    isHidden(element) {
        return (element.offsetParent === null);
    }

    contactsExpanded() {
        console.log('Contacts expanded');
        var self = this;
        _.forEach(_.pairs(self.maps), function (pair) {
            console.log(pair[0]);
            var group = pair[0];
            var map = pair[1];

            gMaps.event.trigger(map, 'resize');

            var rx = new RegExp('^q\\:in bounds\\((.*),(.*),(.*),(.*)\\)$');
            var res = rx.exec(group); //Ex: q:in bounds(2.45,4.78,3,42)
            if (res) {
                var south = parseFloat(res[1]);
                var west = parseFloat(res[2]);
                var north = parseFloat(res[3]);
                var east = parseFloat(res[4]);

                var center = new gMaps.LatLng((south + north) / 2, (west + east) / 2);
                map.setCenter(center);

                var bounds = {south: south, west: west, north: north, east: east};
                map.fitBounds(bounds);
            }
        });
    }

    setStatusFor(type, model, status, prefix) {
        var obj = Handlebars.helpers.getStatusAndIconFor(type, model, status);
        $(`#${prefix}${type}StatusIcon`).html(obj.htmlIcon);
        $(`#${prefix}${type}StatusText`).html(obj.htmlText);
        $(`#${prefix}${type}-creation-date`).html(obj.htmlCreation);
    }

    convertSeconds(delaySecond) {
        const MINUTE = 60;
        const HOUR = 60 * MINUTE;
        const DAY = 24 * HOUR;

        const days = Math.floor(delaySecond / DAY);
        delaySecond  -= days*DAY;
        const hrs   = Math.floor(delaySecond / HOUR);
        delaySecond  -= hrs*HOUR;
        const mnts = Math.floor(delaySecond / MINUTE);
        delaySecond  -= mnts*MINUTE;

        if (days > 0 && hrs > 0 && mnts > 0)  {
            return  i18n.t("message.days", {count : days}) + " " +  i18n.t("message.hours", {count : hrs}) + " " + i18n.t("message.minutes", {count : mnts});
        } else if (days > 0 && hrs > 0) {
            return  i18n.t("message.days", {count : days}) + " " + i18n.t("message.hours", {count : hrs});
        } else if (days > 0 && mnts > 0) {
            return  i18n.t("message.days", {count : days}) + " " + i18n.t("message.minutes", {count : mnts});
        } else if (hrs > 0 && mnts > 0) {
            return i18n.t("message.hours", {count : hrs}) + " " + i18n.t("message.minutes", {count : mnts});
        } else if (hrs > 0) {
            return i18n.t("message.hours", {count : hrs});
        } else if (mnts > 0) {
            return i18n.t("message.minutes", {count : mnts});
        } else {
            return i18n.t("message.noDelay");
        }
    }
}

export default MessageReportView;
